import styled from '@emotion/styled'
import PropTypes from 'prop-types'

import { MOBILE } from '../guided-toolbox/utils/breakpoints'
import {
  BUTTON_VARIANTS,
  DEFAULT_BUTTON_WIDTH,
  buttonBase,
  mobileFullWidth,
  variantStyles,
} from './buttonStyles'

const Box = styled.button`
  ${buttonBase};
  flex-direction: column;
  gap: 2px;
  min-width: ${DEFAULT_BUTTON_WIDTH};
  min-height: 75px;
  padding: 14px 32px;
  text-align: center;

  ${variantStyles};
  ${mobileFullWidth};

  ${MOBILE} {
    min-width: 0;
  }
`

const Label = styled.span`
  font-size: 18px;
  font-weight: 600;
  line-height: 22px;
`

const Sublabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
`

/** A button with a primary label and optional supporting text. */
const MultiLineButton = ({ label, sublabel, variant = 'primary', type = 'button', ...rest }) => (
  <Box variant={variant} type={type} {...rest}>
    <Label>{label}</Label>
    {sublabel && <Sublabel>{sublabel}</Sublabel>}
  </Box>
)

MultiLineButton.propTypes = {
  label: PropTypes.node.isRequired,
  sublabel: PropTypes.node,
  variant: PropTypes.oneOf(BUTTON_VARIANTS),
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
}

export default MultiLineButton
